import Vue from 'vue';
import Router from 'vue-router';
import Home from './components/Home.vue';

Vue.use(Router);

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/product',
      name: 'Product',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './components/Products.vue'),
    },
    {
      path: '/resources',
      name: 'Resources',
      component: () => import('./components/Resources.vue'),
    },
    {
      path: '/Company',
      name: 'Company',
      component: () => import('./components/Company.vue'),
    },
    {
      path: '/governments',
      name: 'Governments',
      component: () => import('./components/Governments.vue'),
    },
    {
      path: '/merchant',
      name: 'Merchant',
      component: () => import('./components/Merchants.vue'),
    },
  ],
});
